import { createColumnHelper } from "@tanstack/react-table";
import DataTable from "components/datatable/datatable";
import Loader from "components/loader";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { convertToDDMMYYYYWithTime, stripHtmlTags } from "utils/utils";
import { getAllCronJobs } from "../../../axios/api";
import Modal from "react-modal";
import "./style.css";

const CronJobs = () => {
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    filter: {},
  });
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [cronJobsData, setCronJobsData] = useState<any>();
  const columnHelper = createColumnHelper<any>();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");

  const handleOpenModal = (message: string) => {
    setSelectedMessage(message);
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setSelectedMessage("");
  };

  const columns: any = [
    columnHelper.accessor("name", {
      id: "name",
      header: () => (
        <p className="text-base font-normal text-[#424242] dark:text-white">
          Cron Jobs
        </p>
      ),
      cell: (info) => (
        <div className="flex items-center">
          <p className="ml-3 flex items-center  text-sm font-bold text-navy-700 dark:text-white">
            {stripHtmlTags(info.getValue())}
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: () => (
        <p className="text-base font-normal text-[#424242] dark:text-white">
          Status
        </p>
      ),
      cell: (info) => (
        <div className="flex items-center">
          <p className="ml-3 flex items-center  text-sm font-bold text-navy-700 dark:text-white">
            {info && info?.row?.original?.image ? (
              <img
                src={info.row.original?.image}
                alt="cover"
                className="me-3 w-8"
              />
            ) : null}
            {stripHtmlTags(info.getValue())}
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("error_msg", {
      id: "error_msg",
      header: () => (
        <div className="flex items-center justify-center">
          <p className="text-base font-normal text-[#424242] dark:text-white">
            Error Message
          </p>
        </div>
      ),
      cell: (info) => (
        <p
          className="flex max-h-5 w-full justify-center overflow-hidden dark:text-white"
          onClick={() => info.getValue() && handleOpenModal(info.getValue())}
          style={{ cursor: "pointer" }}
        >
          <div className="max-w-[7rem] dark:text-white" />
          {info.getValue()
            ? info.getValue().length > 30
              ? info.getValue().slice(0, 30) + " ..."
              : info.getValue()
            : "-"}
        </p>
      ),
    }),
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: () => (
        <div className="flex items-center justify-center">
          <p className="text-base font-normal text-[#424242] dark:text-white">
            Created Date
          </p>
        </div>
      ),
      cell: (info) => (
        <p className=" flex max-h-5  w-full justify-center overflow-hidden dark:text-white">
          <div className="max-w-[20%] dark:text-white" />
          {convertToDDMMYYYYWithTime(
            info.getValue()?.slice(0, 10) + " " + info.getValue()?.slice(11, 19)
          )}
        </p>
      ),
    }),
  ];

  useEffect(() => {
    const fetchCronJobs = async () => {
      try {
        setLoading(true);
        const cronJobsDataResp = await getAllCronJobs(
          filter.page,
          filter.limit
        );
        setCronJobsData(cronJobsDataResp?.data?.data?.cronJobs);
        setTotalCount(cronJobsDataResp?.data?.data?.totalResults);
        if (!cronJobsDataResp?.data?.success) {
          toast.error("Error Fetcing Cron Jobs");
          // console.log("cronJobsDataResp", cronJobsDataResp);
        }
      } catch (error) {
        toast.error("Error Fetcing Cron Jobs");
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCronJobs();
  }, [filter]);

  const onPageChange = ({ selected }: any) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      page: selected + 1,
    }));
  };
  return (
    <>
      {loading && <Loader />}
      <div className="h-full rounded-md bg-white">
        <div className="flex justify-between p-4">
          <span className="text-2xl font-bold">Cron Jobs</span>
        </div>
        <div>
          {cronJobsData && cronJobsData.length > 0 ? (
            <DataTable columns={columns} tableData={cronJobsData} />
          ) : (
            <div className="flex min-h-[80vh] items-center justify-center text-4xl	font-bold	">
              {!loading ? "No Cron Jobs Found" : ""}
            </div>
          )}
        </div>
        <ReactPaginate
          className="pagination"
          previousLabel={"<<"}
          nextLabel={">>"}
          breakLabel={"..."}
          pageCount={Math.ceil(totalCount / filter.limit)}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={onPageChange}
          containerClassName={"pagination"}
          activeClassName={"active"}
          pageClassName={"page"}
          previousClassName={"previous"}
          nextClassName={"next"}
          breakClassName={"break"}
          disabledClassName={"disabled"}
        />
      </div>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleCloseModal}
        className="modal"
      >
        <h2 className="error-msg">Error Message : </h2>
        <div>{selectedMessage}</div>
      </Modal>
    </>
  );
};

export default CronJobs;
